import axios from "axios";

export const getAddonsItemNameList = async () => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/list/addOns-list`,
      config
    );
    return data?.data?.result;
  } catch (error) {
    console.log(error);
    return error;
    // return error?.response?.data?.result;
  }
};
